import ApiService from '../../api/ApiService'
import { useLayoutEffect, useRef, useState, useEffect } from 'react'
import '../../css/Livepooja.scss'
import ScrollTrigger from 'gsap/ScrollTrigger'


const LivePooja = () => {

    return (
        <section className="p-0">
            <div className="container">
                <div className="schedule">
                    <div className="info">
                        <h7>Blessing from Radha Madhava</h7>
                        <h2>Online Live Zoom Puja</h2>

                        <p>Join us via the Zoom link for a Special Puja.</p>
                        <p>Offer prayers at the lotus feet of Sri Sri Radha Madhava for the special blessings upon you and your family.</p>
 
                        <p className="p3">With gratitude, ISKCON Attapur</p>
                    </div>

                    <div className="timing">
                        <h1>Join Zoom Meeting</h1>

                        <div className="schedule-row">
                            <div className="time-container">
                                <p className="time">Online Puja</p>
                            </div>
                            <div className="arrow-container">
                                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" style={{ marginRight: "5px" }}>
                                    <circle cx="4" cy="4" r="4" fill="#FFC84F" />
                                </svg>
                            </div>
                            <p className="p4">Everyday 12:30 PM</p>
                        </div>
                        <div>
                            <a
                                href="https://zoom.us/j/99399022878?pwd=Ie4lGKb6Mc8wuVFvkWCipnJNtRmrAY.1"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <button className="button3">
                                    Join Live Zoom Puja
                                </button>
                            </a>
                        </div>

                    </div>
                </div>
            </div>
        </section >
    );
}

export default LivePooja